import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidebarIconReportsOld = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "reports",
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M35.9,4.4l-7.4,9.7c-0.7,0.9-2.1,1.3-3.2,1l-4.7-1.4c-1.1-0.3-2.3,0.2-2.7,1.3l-4.6,10.2 c-0.4,1-1.6,1.4-2.5,0.8l-2.1-1.2c-1-0.6-2.1-0.2-2.6,0.8l-3.7,7.8c-0.8,1.7,0.1,3.1,2,3.1h0.9h28.5h0.9c1.9,0,3.4-1.6,3.4-3.4v-1.4 V5.4V5.1C38,3.2,37,2.9,35.9,4.4z" })
});
export default SvgSidebarIconReportsOld;
